import $ from "jquery";

export class LibrarySearch {
    constructor($el) {
        this.$el = $el;
        this.$inputField = $(this.$el).find("#searchInput");
        this.$searchButton = $(this.$el).find(".btn--primary")[0];
        // this.$dropdown = $(this.$el).find("#searchOptions");

        // this.$baseUrls = {
        //     "Everything": "https://drexel.primo.exlibrisgroup.com/discovery/search?query=any,contains,REPLACEME&tab=Everything&vid=01DRXU_INST:01DRXU&lang=en&offset=0&pcAvailability=true",
        //     "All": "https://drexel.primo.exlibrisgroup.com/discovery/search?query=any,contains,REPLACEME&tab=Everything&vid=01DRXU_INST:01DRXU&lang=en&offset=0&pcAvailability=true",
        //     "Books_and_More": "https://drexel.primo.exlibrisgroup.com/discovery/search?query=any,contains,REPLACEME&tab=LibraryCatalog&vid=01DRXU_INST:01DRXU&lang=en&offset=0",
        //     "Ejournals": "https://drexel.primo.exlibrisgroup.com/discovery/jsearch?query=any,contains,REPLACEME&tab=jsearch_slot&vid=01DRXU_INST:01DRXU&offset=0&journals=any,REPLACEME",
        //     "Subject_Guides": "https://libguides.library.drexel.edu/srch.php?q=REPLACEME",
        //     "Drexel_Research_Collections": "https://researchdiscovery.drexel.edu/esploro/search/outputs?query=any,contains,REPLACEME&page=1&sort=rank&scope=Research&institution=01DRXU_INST",
        //     "Drexel_Archival_Collections": "https://drexel.primo.exlibrisgroup.com/discovery/search?query=any,contains,REPLACEME,AND&pfilter=rtype,exact,archival_materials,AND&tab=Everything&sortby=rank&vid=01DRXU_INST:01DRXU&lang=en&mode=advanced&offset=0",
        // };

        this.bindEvents();
    }

    bindEvents() {
        $(this.$searchButton).on("click", () => this.performSearch());

        if (this.$inputField.length) {
            this.$inputField.get(0).addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    event.preventDefault();
                    this.performSearch();
                }
            });
        }
    }
    

    performSearch() {
        const query = encodeURIComponent(this.$inputField.val().trim());
        // const selectedOption = this.$dropdown.val();
        // console.log(this.$dropdown[0].options.selectedIndex);
        // console.log(this.$dropdown[0].options[this.$dropdown[0].options.selectedIndex].getAttribute("data-base-url"));
        const baseUrl = "https://drexel.primo.exlibrisgroup.com/discovery/search?query=any,contains,REPLACEME&tab=Everything&vid=01DRXU_INST:01DRXU&lang=en&offset=0&pcAvailability=true";
        //const baseUrl = this.$baseUrls[selectedOption];

        if (baseUrl) {
            let updatedUrl = baseUrl.replace(/REPLACEME/g, query);
            window.open(updatedUrl, "_blank");
        }
    }
}